module.exports = __webpack_public_path__ + "img/beetle.54cceba0.png";